import { render, staticRenderFns } from "./LeaveRequestBreakdowns.vue?vue&type=template&id=88abf216"
import script from "./LeaveRequestBreakdowns.vue?vue&type=script&lang=js"
export * from "./LeaveRequestBreakdowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports